import React, {forwardRef, useRef} from 'react';
import style from './style';

const FicheContextContent = forwardRef(({children}, navigationRef) => {
  const {classes} = style();
  const navHidderRef = useRef();

  const handleScroll = () => {
    if(!navigationRef || !navigationRef.current) return;
    const rect = navigationRef.current.getBoundingClientRect();
    if (rect.top < 78) {
      navigationRef.current.classList.add('top');
      navHidderRef.current.classList.add('show');
    } else {
      navigationRef.current.classList.remove('top');
      navHidderRef.current.classList.remove('show');
    }
  }

  return (<>
    <div className={classes.navigationHidder} ref={navHidderRef}></div>
    <div className={classes.root} onScroll={handleScroll}>
      <div className={classes.container}>
        {children}
      </div>
    </div>
  </>)
})

export default FicheContextContent;